const GlobalSpinner = {
  show: function(){
    var element = document.getElementById('js-ajax-spinner');

    if(element){
      element.style.display = 'block';
    }
  },
  hide: function(){
    var element = document.getElementById('js-ajax-spinner');
    if(element){
      element.style.display = 'none';
    }
  }
}

export default GlobalSpinner;
